import React, { useContext } from "react";
import { Link } from "react-router-dom";
// import { DisplayDiscussionForMiniScreenProvider } from "../contexts/DisplayDiscussionForMiniScreenContext";
import ContentFormSquelette from "../layouts/ContentFormSquelette";
import { FaArrowLeftLong } from "react-icons/fa6";
import error404 from "../assets/img/rb_page_404.png";
import { ThemeContext } from "../contexts/ThemeContext";

export default function Error404Page() {
  const { theme } = useContext(ThemeContext);
  return (
    <>
      <ContentFormSquelette>
        <div className="conatiner">
          <div className="tyn-content d-flex justify-content-center align-items-center">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-4 col-lg-5 col-md-6 col-sm-8">
                  <div className="px-4 animate__animated animate__pulse animate__infinite">
                    <img
                      className="w-100"
                      src={error404}
                      alt="Error_page_404"
                    />
                  </div>
                  <div className="tyn-text-block text-center pt-5">
                    <h1
                      style={{ fontSize: "20px" }}
                      className={theme === "dark" ? "text-white" : "text-black"}
                    >
                      Désolé! La page n'existe pas
                    </h1>
                    <p
                      className={
                        theme === "dark"
                          ? "text-white px-xl-4"
                          : "text-black px-xl-4"
                      }
                    >
                      Il semblerait que vous soyez tombé sur une page qui
                      n'existe pas.
                    </p>
                    <Link to="/" className="btn btn-primary mt-2">
                      <FaArrowLeftLong /> Retour à l'accueil
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentFormSquelette>
    </>
  );
}
